import { styled } from '@mui/material/styles';
import { Box, FormControl, OutlinedInput } from '@mui/material';

interface SearchBarContainerProps {
  mb?: number;
  mt?: number | string;
}

export const SearchBarContainer = styled(Box)<SearchBarContainerProps>(
  ({ mb = 3, mt }) => ({
    marginBottom: typeof mb === 'number' ? `${mb * 8}px` : mb,
    marginTop: mt,
  })
);

export const SearchBarFormControl = styled(FormControl)({
  width: '100%',
  margin: 0,
});

interface StyledSearchInputProps {
  height?: string;
  width?: string;
  maxWidth?: string;
}

export const StyledSearchInput = styled(OutlinedInput)<StyledSearchInputProps>(
  ({ height = '40px', width = '450px', maxWidth }) => ({
    height: height,
    width: width,
    maxWidth: maxWidth,
    backgroundColor: 'var(--text-bg)',
    borderColor: 'var(--border)',
    borderRadius: '8px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--border)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--border)',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--border)',
    },
    '& input': {
      fontFamily: 'Outfit',
      fontSize: '14px',
      '&::placeholder': {
        fontWeight: 300,
      },
    },
    overflow: 'hidden',
  })
);

export const SearchIcon = styled(Box)({
  color: 'var(--primary-blue)',
  fontSize: '16px',
});
